import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'times',
})
export class TimesPipe implements PipeTransform {
  transform(length: number, from = 0): number[] {
    if (length < 0) {
      length = 0;
    }
    return Array.from({ length }).map((_, i) => i + from);
  }
}
